import { queryOptions } from '@tanstack/react-query';
import type { WorkFocus, WorkScope, WorkToday } from '@erp/shared';
import { api } from '@/lib/api-client';

/** Família do Hoje — o realtime (ticket/conversa mudou) invalida por ela. */
export const WORK_KEY = ['erp', 'work'] as const;

export function workTodayQuery(scope: WorkScope, focus: WorkFocus | undefined) {
  return queryOptions({
    queryKey: [...WORK_KEY, 'today', { scope, focus: focus ?? null }] as const,
    queryFn: async ({ signal }) => {
      const res = await api<WorkToday>('/work/today', {
        query: { scope, ...(focus ? { focus } : {}) },
        signal,
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
